import styled from "styled-components";
import { BASIC_BROWN, BASIC_YELLOW } from "../../constants/colors";
import { MenuInCart } from "../../ducks/menu";
import { useAsset } from "../../hooks/useAsset";
import { useHeader } from "../../hooks/useHeader";
import { HeaderMenuItem } from "../molecules/HeaderMenuItem";
import { AppCouponHeader } from "./AppCouponHeader";
import { MenuReorderHeader } from "./MenuReorderHeader";

type Props = {
  showAppCouponHeader: boolean;
  menusToReorder?: MenuInCart[] | null;
  requiredLogout?: boolean;
  isMaintenance?: boolean;
};

export const Header: React.FC<Props> = ({
  showAppCouponHeader,
  menusToReorder,
  requiredLogout,
  isMaintenance,
}) => {
  const {
    handleLogoClick,
    handleCancelAppCoupon,
    handleCancelReorder,
    handleLanguageSelectClick,
    handleUserGuideClick,
    handleLoginClick,
    handleMyPageClick,
  } = useHeader(requiredLogout);
  const { baseDir } = useAsset();

  return (
    <HeaderContainer id="app-header">
      <HeaderContent>
        <LogoContainer onClick={handleLogoClick}>
          <img
            src={`${baseDir}/assets/images/logo.png`}
            alt="joyfull テイクアウト"
            width="147"
            height="27"
            srcSet={`${baseDir}/assets/images/logo@2x.png`}
          />
        </LogoContainer>

        {!isMaintenance && (
          <HeaderMenuContainer>
            <HeaderMenuItem
              handleLanguageSelectClick={handleLanguageSelectClick}
              handleUserGuideClick={handleUserGuideClick}
              handleLoginClick={handleLoginClick}
              handleMyPageClick={handleMyPageClick}
            />
          </HeaderMenuContainer>
        )}
      </HeaderContent>

      {menusToReorder && (
        <MenuReorderContainer>
          <MenuReorderHeader onCancel={handleCancelReorder} />
        </MenuReorderContainer>
      )}

      {showAppCouponHeader && (
        <AppCouponHeader onCancel={handleCancelAppCoupon} />
      )}
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  border-bottom: 3px solid ${BASIC_YELLOW};
  min-width: 375px;
  z-index: 9998;
`;

const HeaderContent = styled.div`
  display: flex;
  text-align: left;
  background-color: ${BASIC_BROWN};
  padding: 8px 13px 8px 16px;
`;

const LogoContainer = styled.div`
  margin: 1px 0 0 0;
  cursor: pointer;
`;

const HeaderMenuContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

const MenuReorderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  border-bottom: 3px solid ${BASIC_YELLOW};
  min-width: 375px;
  z-index: 9999;
`;
